import { observer, useLocalObservable } from "mobx-react";
import React, { useEffect, useState } from "react";
import TimelinePageListView from "./TimelinePageListView";
import TimelinePageStore from "./store/TimelinePageStore";
import FilterButton from "./component/FilterButton";
import "./styles.css";
import TimelineDrawer from "./component/TimelineDrawer";

interface Props {
  pageStore: TimelinePageStore;
}

function TimelinePage(props: Props) {
  const [isDrawerVisible, setIsDrawerVisible] = React.useState<boolean>(false);

  useEffect(() => {
    const PAS = localStorage.getItem("PAS");
    console.log(PAS);
    const pasObject = JSON.parse(PAS as string);
    console.log(pasObject, pasObject._currentUser);
    props.pageStore.setUserInfo(pasObject._currentUser);
    props.pageStore.fetchAsssessList(pasObject._currentUser.id);
  }, []);

  return (
    <>
      <div style={{height:50}}>
        <FilterButton isFilterIcon={true} onClickFilter={setIsDrawerVisible} />
      </div>
      <TimelinePageListView pageStore={props.pageStore} />
      <TimelineDrawer
        isDrawerVisible={isDrawerVisible}
        setIsDrawerVisible={setIsDrawerVisible}
        pageStore={props.pageStore}
      />
    </>
  );
}

export default observer(TimelinePage);
